import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Header } from './Header';
import { Sidebar } from './Sidebar';
import { ToastViewport } from '@/components/ui/Toast';

export function AppLayout() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <div className="flex h-full flex-col">
      <Header onMobileMenuToggle={() => setMobileMenuOpen((v) => !v)} />
      <div className="flex flex-1 overflow-hidden">
        <Sidebar
          mobileOpen={mobileMenuOpen}
          onMobileClose={() => setMobileMenuOpen(false)}
        />
        {/* `isolate` creates a new stacking context so Leaflet's
            internal pane z-indexes (200–1000, including the layer
            control + zoom widget at 1000) stay scoped to <main>. Without
            this, the map widgets punched through the sidebar drawer
            (z-50) on narrow viewports. */}
        {/* Vertical padding stays tighter than horizontal: on 768 px-tall
            laptops every row of chrome costs a row of table data. */}
        <main className="isolate flex-1 overflow-auto bg-[#f8faf9] p-3 sm:px-4 sm:py-3 lg:px-6 lg:py-4 dark:bg-slate-900">
          <Outlet />
        </main>
      </div>
      <ToastViewport />
    </div>
  );
}
